import { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { useIsClientReady } from '@belong/common';
import { Button } from '@belong/ui';
import clsx from 'clsx';

export type MobileBottomBarProps = {
  header?: ReactNode;
  className?: string;
  nextText?: string;
  onNext: () => void | Promise<void>;
  disabled?: boolean;
};

export function MobileBottomBar({
  header,
  className,
  nextText = 'Next',
  onNext,
  disabled,
}: MobileBottomBarProps) {
  const isClientReady = useIsClientReady();
  if (!isClientReady) return null;

  return createPortal(
    <div
      className={clsx(
        'inset-x-2sm bottom-2xs fixed bg-white pb-[max(env(safe-area-inset-bottom),12px)] md:hidden',
        className,
      )}
    >
      {header}
      <div className="gap-xs flex">
        <Button
          type="submit"
          variant="solid"
          buttonType="primary"
          className="flex-1"
          onClick={onNext}
          disabled={disabled}
        >
          {nextText}
        </Button>
      </div>
    </div>,
    document.getElementById('bottom-bar') as Element,
  );
}
